<template lang="pug">
AppDialog.reset-mfa-dialog(
  :key="show"
  append-to-body
  :show="show"
  title="Confirm reset 2FA"
  @close="close"
)
  .dialog-p
    | This will delete {{ user.name }}'s existing authentication codes and require them to restart the 2FA
    |
    | process to log in again.
  .flex-footer(slot="footer")
    AppButton(@click="close") Cancel
    AppButton(
      type="danger"
      :disabled="resetDisabled"
      @click="handleSubmit"
    ) {{ resetLabel }}
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ConfirmReset2faDialog',
  props: {
    organizationId: {
      type: Number,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    submitting: false,
  }),
  computed: {
    resetDisabled() {
      return this.submitting;
    },
    resetLabel() {
      return this.submitting ? 'Resetting 2FA...' : 'Reset 2FA for member';
    },
  },
  methods: {
    ...mapActions(['disable2faForUser']),
    close() {
      this.$emit('close');
    },
    handleSubmit() {
      this.submitting = true;
      this.disable2faForUser({ organizationId: this.organizationId, userId: this.user.id }).then(
        this.completeRequest,
        this.handleErrors,
      );
    },
    completeRequest(response) {
      this.submitting = false;

      if (response && response.success) {
        this.handleSuccess();
      } else {
        const resp = response ? response.error : '2FA was was not disabled';

        this.handleErrors(resp);
      }
    },
    handleSuccess() {
      this.$appMessage(`2FA was disabled for ${this.user.name}`);
      this.close();
    },
    handleErrors(response) {
      this.$appMessage(response);
    },
  },
};
</script>
